import { createSlice } from "@reduxjs/toolkit";
import categoryInitialState from "@/components/CategoryPage/redux/initialState";
import CategoryReducer from "@/components/CategoryPage/redux/reducers";

const categorySlice = createSlice({
  name: "category",
  initialState: categoryInitialState,
  reducers: CategoryReducer,
});

export const { setCategoryData, setLoading, setError, setDevice, setCategorySlug } = categorySlice.actions;

export default categorySlice.reducer;
